import React, { useEffect, useState } from 'react'
import scheduleIdleCallback from 'src/util/scheduleIdleCallback'

interface DeferredMountProps {
  children: React.ReactNode
  /** ms fallback if requestIdleCallback isn't available or never fires */
  timeout?: number
}

/**
 * Delays mounting its children until the browser is idle (or `timeout` elapses), so
 * non-critical integrations don't delay first paint. `timeout` is only read on mount — pass a
 * stable value, since changing it later does not reschedule.
 */
export default function DeferredMount({ children, timeout = 2000 }: DeferredMountProps) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    return scheduleIdleCallback(() => setReady(true), timeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ready ? <>{children}</> : null
}
